import z from 'zod';

export type Theme = 'light' | 'dark';

export enum AppVisibilityMode {
  StatusBar = 'StatusBar',
  DockAndStatusBar = 'DockAndStatusBar',
}

export enum AppManagerCommands {
  GetAppVisibilityMode = 'app-manager-get-app-visibility-mode',
  SetAppVisibilityMode = 'app-manager-set-app-visibility-mode',
}

export const SetAppVisibilityModePayloadSchema = z.object({
  mode: z
    .nativeEnum(AppVisibilityMode)
    .default(AppVisibilityMode.DockAndStatusBar),
});
